import React, { useContext, useEffect } from "react";
import Login from "./components/Login/Login";
import App from "./App";
import gql from "graphql-tag";
import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  useLazyQuery,
  useQuery,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { UserContext } from "./contexts/UserContext";
import { UIContext } from "./contexts/UIContext";

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : "",
    },
  };
});

const httpLink = createHttpLink({
  uri:
    (window.ENV?.REACT_APP_PROJECT_SERVER ||
      process.env.REACT_APP_PROJECT_SERVER) + "/graphql",
});

const user_client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

const LOGGED_IN = gql`
  query LoggedIn {
    me {
      username
      token
    }
  }
`;

const GET_ENGINES = gql`
  query GetEngines {
    enginesForUser {
      name
      _id
      key
    }
  }
`;

const GET_UI_PROFILE = gql`
  query GetUIProfile($app: String!) {
    uiProfileForUser(app: $app) {
      app
      _id
      data
    }
  }
`;

function Main() {
  const { setUserToken } = useContext(UserContext);
  const { setUIProfileJSON } = useContext(UIContext);
  const {
    loading,
    error,
    data,
    refetch: refetchLogin,
  } = useQuery(LOGGED_IN, {
    fetchPolicy: "network-first",
    client: user_client,
  });
  const [getUIProfile, { data: ui_profile }] = useLazyQuery(GET_UI_PROFILE, {
    fetchPolicy: "network-first",
    client: user_client,
  });
  useEffect(() => {
    if (data) {
      setUserToken(data.me.token);
      getUIProfile({
        variables: { app: "football" },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    try {
      if (ui_profile) {
        let obj = JSON.parse(ui_profile?.uiProfileForUser?.data);
        setUIProfileJSON(obj);
      }
    } catch (err) {
      console.log(err);
    }
  }, [ui_profile]);

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  let isEngine = getParameterByName("engine") === "true";
  if (isEngine) {
    let token = getParameterByName("user-token");
    localStorage.setItem("token", token);
  }
  window.hideHeader = getParameterByName("show_header") === "false";
  return (
    <>
      {!isEngine && !data?.me?.token && (
        <Login
          loggedIn={() => {
            refetchLogin();
          }}
        />
      )}
      {(isEngine || data?.me?.token) && <App loggedIn={data?.me} />}
    </>
  );
}

export default function Startup() {
  return <Main />;
}
